import React from "react";

interface Props {
  size?: number;
  tone?: "brand" | "onDark";
  className?: string;
}

// Logo mark STRUKTURKU: tiga batang menaik (identik dengan favicon/app icon).
export function LogoMark({ size = 32, tone = "brand", className }: Props) {
  const bars = tone === "onDark"
    ? ["#4d86f0", "#93b4f7", "#ffffff"]
    : ["#2f6bed", "#8fb4f5", "#14294a"];
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect x="4" y="17" width="6" height="9" rx="1.8" fill={bars[0]} />
      <rect x="13" y="12" width="6" height="14" rx="1.8" fill={bars[1]} />
      <rect x="22" y="7" width="6" height="19" rx="1.8" fill={bars[2]} />
    </svg>
  );
}
